import React from "react";
import {
  Box, Typography, Table, TableHead, TableRow,
  TableCell, TableBody
} from "@mui/material";
import { useSelector } from "react-redux";

const LesenTab = () => {
  const { lesenPassage } = useSelector((state) => state.einstufung);

  if (!lesenPassage) return <Typography p={2}>Keine Daten verfügbar</Typography>;

  return (
    <>
      <Box p={2}>
        <Typography variant="h6">{lesenPassage.title}</Typography>
        {lesenPassage.content.split("\n\n").map((para, idx) => (
          <Typography key={idx} paragraph>{para}</Typography>
        ))}
      </Box>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Frage</TableCell>
            <TableCell>Optionen</TableCell>
            <TableCell>Korrekte Antwort</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lesenPassage.questions.map((q) => (
            <TableRow key={q.id}>
              <TableCell>{q.questionText}</TableCell>
              <TableCell>
                {q.options.map((opt, idx) => (
                  <div key={idx}>{opt}</div>
                ))}
              </TableCell>
              <TableCell>{q.correctAnswer}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};

export default LesenTab;
